<vi-page [sidenavs]="true" [footer]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-icon-button
      data-at-breadcrumb-back
      left
      gtm="onBreadcrumbBack"
      gtmCategory="notFound"
      [routerLink]="['/installations']"
      >arrow_back</vi-icon-button
    >
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="notFound"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body [centered]="true">
    <vi-empty
      main
      gtm="onGoToPage"
      gtmAction="Installations"
      gtmCategory="notFound"
      gtmLabel="notFound"
      [header]="header | translate"
      [content]="content | translate"
      [redirectBtn]="redirectBtn | translate"
      [redirectLink]="redirectLink"
      [imgSrc]="imgSrc"
    >
    </vi-empty>
  </vi-content>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
